module.exports = __webpack_public_path__ + "static/media/BgListMembers.665805f1.png";